import React from 'react';
import { Checkbox, FormControl, FormLabel } from '@chakra-ui/react';
import {
  buildCategoryTree,
  type CategoryTreeNode,
} from '../../../../helpers/categoryTree.helper';
import type { Category } from '../../application/types';
import './CategoryTreeField.scss';

type CategoryTreeFieldProps = {
  categories: Category[];
  value: string[];
  onChange: (next: string[]) => void;
  label?: string;
};

function CategoryTreeNodes({
  nodes,
  selected,
  onToggle,
}: {
  nodes: CategoryTreeNode<Category>[];
  selected: Set<string>;
  onToggle: (id: string) => void;
}) {
  return (
    <ul className="category-tree">
      {nodes.map((node) => {
        const id = String(node.id);
        const isParent = node.children.length > 0;
        return (
          <li key={node.id}>
            {isParent ? (
              <span className="category-tree__parent">{node.name}</span>
            ) : (
              <Checkbox
                isChecked={selected.has(id)}
                onChange={() => onToggle(id)}
              >
                {node.name}
              </Checkbox>
            )}
            {isParent ? (
              <CategoryTreeNodes
                nodes={node.children}
                selected={selected}
                onToggle={onToggle}
              />
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}

export const CategoryTreeField: React.FC<CategoryTreeFieldProps> = ({
  categories,
  value,
  onChange,
  label,
}) => {
  const tree = buildCategoryTree(categories);
  const selected = new Set(value);

  const onToggle = (id: string) => {
    const next = selected.has(id)
      ? value.filter((item) => item !== id)
      : [...value, id];
    onChange(next);
  };

  return (
    <FormControl className="category-tree-field">
      {label ? <FormLabel>{label}</FormLabel> : null}
      <CategoryTreeNodes nodes={tree} selected={selected} onToggle={onToggle} />
    </FormControl>
  );
};
